// Libs
import { Stack } from '@mui/material';
import classNames from 'classnames/bind';
// Components, Layouts, Pages
import { ClientList } from '~/components/module/client';
// Others
import { TypeCrmEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './Lead.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Lead = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='leadPage' className={cx('container')}>
      <ClientList typeList={TypeCrmEnum.LEAD} />
    </Stack>
  );
};

export default Lead;
